/**
 * Import blocks
 */

//import "./style.scss";
//import "./editor.scss";

import './text-expand-faqs';
import './box-expand-faqs';
import './accordion-expand-faqs';
import './schema-option.js';
//import "./flexible-faqs-submit";
